module.exports = __webpack_public_path__ + "img/dsci0120.909944be.jpg";